<template>
    <a :href="route('credit.show', {
    customer: result.customer_id,
    credit: result.id,
})">
  <div class="result-card">
    <div class="flex-row align-items-center justify-content-between gap-sm">
      <div class="flex-row gap-sm align-items-center ">
        <UmbrellaIcon class="fill-primary icon-size-lg"></UmbrellaIcon>
        <div class="grid">
          <p class="font-size-md mb-xxs color-primary">
            {{ result.number }}
          </p>
          <small>

          </small>
        </div>
      </div>
      <div class="">
        <Customer :customer-id="result.customer_id"></Customer>
      </div>
    </div>
  </div>
    </a>
</template>

<script>
import Customer from '../components/Customer.vue';
export default {
  name: "Credit",
  components: {
    Customer,
  },
  data() {
    return {

    };
  },
  props: {
    result: {
      number: {
        type: Number,
        required: false,
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>